<app-header></app-header>
<app-menu></app-menu>
<main class="main-content">
  <router-outlet></router-outlet>
</main>
<app-rackeo-footer-shell></app-rackeo-footer-shell>
